import React, {Component} from 'react'
import PropTypes from 'prop-types'
import actions from 'redux-form/lib/actions'
import {event} from '@cred/shared/ga'
import {simpleMessage} from '../error'
import styles from './styles.module.scss'

class Rating extends Component {
  static propTypes = {score: PropTypes.oneOf([0, 1, 2, 3, 4, 5])};

  static defaultProps = {score: 0};

  constructor(props) {
    super(props)

    this.state = {value: props.score, showing: props.score}

    this.showScore = this.showScore.bind(this)
    this.resetScore = this.resetScore.bind(this)
    this.setScore = this.setScore.bind(this)
  }

  render() {
    const {className, meta, input, label} = this.props

    return (
      <div className={[styles.rating, className].join(' ')}>
        <div className="mb-8">
          <label>{label}</label>
        </div>
        <span data-score={1} className={this.scoreClass(this.state.showing, 1)} onMouseOver={this.showScore} onMouseOut={this.resetScore} onClick={this.setScore}/>
        <span data-score={2} className={this.scoreClass(this.state.showing, 2)} onMouseOver={this.showScore} onMouseOut={this.resetScore} onClick={this.setScore}/>
        <span data-score={3} className={this.scoreClass(this.state.showing, 3)} onMouseOver={this.showScore} onMouseOut={this.resetScore} onClick={this.setScore}/>
        <span data-score={4} className={this.scoreClass(this.state.showing, 4)} onMouseOver={this.showScore} onMouseOut={this.resetScore} onClick={this.setScore}/>
        <span data-score={5} className={this.scoreClass(this.state.showing, 5)} onMouseOver={this.showScore} onMouseOut={this.resetScore} onClick={this.setScore}/>
        <input type="hidden" {...input} value={this.state.value}/>
        {simpleMessage(meta)}
      </div>
    )
  }

  showScore(proxy) {
    this.setState({showing: parseInt(proxy.currentTarget.attributes['data-score'].value)})
  }

  resetScore() {
    this.setState({showing: parseInt(this.state.value)})
  }

  setScore(proxy) {
    const value = proxy.currentTarget.attributes['data-score'].value

    this.props.meta.dispatch(actions.change(this.props.meta.form, this.props.input.name, value))
    this.setState({value: parseInt(value)})

    if (this.props.gaCategory) {
      event({category: this.props.gaCategory, action: 'Star rating', label: value})
    }
  }

  scoreClass(score, target) {
    return score >= target ? styles.scoreOn : styles.scoreOff
  }
}

export {Rating}

export default Rating
